import { Global } from "@sourceflow-uk/sourceflow-sdk";
import SeoHead from "../../../../components/SeoHead";
import MainBanner from "../../../../components/MainBanner";
import GetInTouch from "../../../../components/GetInTouch";

export default function AboutUs({
  global,
}) {
  return (
    <>
      <SeoHead
        page_name={`Refer A Friend | Science, Engineering & Life Science Recruitment, Jobs & Staffing | SRG`}
        canonical_link={`about-us/refer-a-friend`}
        en_gb={false}
        en_us={true}
      />
      <MainBanner
        global={global}
        pathPrefix={`us.refer_a_friend_page.main_banner`}
        customClass={``}
        content={
          <>
            <h1>Refer a Friend</h1>
          </>
        }
        imageURL1={`/site-assets/images/refer-a-friend.png`}
        imageALT1={`Main Banner`}
        imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
        imageALT2={`Overlay Main Banner`}
      />
      <GetInTouch
        global={global}
        pathPrefix={`us.refer_a_friend_page.get_in_touch.content`}
        customClass={`py-5 grayGradientBg`}
        formId={"94331b95-7621-4317-9a82-5b63ddeb57d3"}
        successPageUrl={"/us/submission-success"}
        content={
          <>
            <h2>How does it work?</h2>
            <div className="my-4">
              <p>
                Good people tend to know good people. In fact, around a third of
                our placements are recommended by existing candidates and
                contractors.
              </p>
              <p>
                So, when you recommend a friend to SRG and we place them in a
                contract or permanent job, you can receive a $250 Love2Shop
                voucher as a thank you.&nbsp;
              </p>
              <p>
                All you need to do is&nbsp;complete the short form&nbsp;at the
                bottom of this page. A referred candidate should satisfy the
                following criteria:
              </p>
              <ul type="disc">
                <li>Not already be registered with us</li>
                <li>Be relevant to the roles and sectors we cover</li>
              </ul>
              <p>
                Once the referred candidate is placed, they must complete 3
                months of work before a reward can be claimed.
              </p>
              <p>
                We will send you your voucher once we have successfully placed
                your friend or colleague into a new job and they have passed the
                probation period.
              </p>
            </div>
            <h5>
              <strong>To refer a friend, please complete the form.</strong>
            </h5>
          </>
        }
        dropDownMenu={false}
      />
    </>
  );
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();

  return {
    props: {
      global,
    },
  };
}
